/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * The schema for creating a draft.
 */
export interface DraftCreate {
    /** The JSON-LD vocabularies used in the draft. */
    jsonLdVocabs?: string[];
    /** Metadata about the draft. */
    meta?: Truvity.DraftMeta;
    /** The source of schema. */
    metaSchema: Truvity.DraftCreateMetaSchema;
    /** The values of the draft. */
    values?: Truvity.CredentialClaimValues;
    /** The VCDM JSON schemas used in the draft. */
    vcdmJsonSchemas?: string[];
}
